import React, { useState, useContext } from 'react';
import './BillingDownloadDataForm.css';
import loaderContext from "../../context/loader/LoaderContext";
import { downloadBillingDataExcelSheet } from '../../service/BillingService';
import { DatePicker, Dropdown } from '@fluentui/react';
import { Spinner,SpinnerSize } from '@fluentui/react';
import ClockLoader from "react-spinners/ClockLoader";
import themeContext from '../../context/theme/ThemeContext';
function BillingDownloadDataForm() {

  const { getThemeColor } = useContext(themeContext);

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [sheetType, setSheetType] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessage2, setErrorMessage2] = useState('');
  const [errorMessage3, setErrorMessage3] = useState('');
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const [downloadRunning, setDownloadRunning] = useState(false);

  const customSpinnerStyle = {
    padding: "auto",
    height: "100vh",
    width: "100vw",
    zIndex: "999",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "black",
    opacity: "0.9",
    position: "fixed",
    top: "0",
    left: "0",
    fontWeight:"bold"
  };

  const billingTextStyle ={
    fontSize: "22px",
    fontWeight: "10px",
    marginTop: "10px",
    color:'#34baeb'
  }

  const billingLoader ={
    fontWeight: "600",
  }

  const dateFormatter = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  };

  const downloadStudies = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setErrorMessage2('');
    setErrorMessage3('');

    if (!fromDate || !toDate || !sheetType) {
      setErrorMessage('Please fill out all fields');
      return;
    }

    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);

    if (fromDateObj > toDateObj) {
      setErrorMessage3('"From date" should be before "To date"');
      return;
    }

    const differenceInDays = (toDateObj - fromDateObj) / (1000 * 3600 * 24);

    if (differenceInDays > 30) {
      setErrorMessage2('Dates difference should not be greater than 31 days');
      return;
    }

    const formattedFromDate = dateFormatter(fromDate);
    const formattedToDate = dateFormatter(toDate);

    const map = new Map();
    map.set('fromDate', formattedFromDate);
    map.set('toDate', formattedToDate);
    map.set('sheetType', sheetType);
    const obj = Object.fromEntries(map);
    const genericDTO = {
      data: obj
    }
    console.log(genericDTO);
    try {
      setDownloadRunning(true);
      
      let res = await downloadBillingDataExcelSheet(genericDTO);
      
      setDownloadRunning(false);
      console.log("download completed.....")
     
    } catch (error) {
      console.error("Error during form data sheet download", error);
    }

  };

  return (
<>
    <>
    { downloadRunning && (
        <div className="billing-spinner" style={customSpinnerStyle}>
            <ClockLoader
                size={150}
                loading={downloadRunning}
                color='#34baeb'
            />
            <p style={billingTextStyle}>File is getting downloaded, Please Wait...</p>
        </div>
    )}
</>
    <div className="main-container-billing-body" style={{ overflow: 'auto' }}>
      <div className="billing-container" style={{border: getThemeColor("border")}}>
        <div style={{ marginBottom: '10px' }}>
          <h3>Billing data sheet download form</h3>
        </div>
        {errorMessage2 && <div className="billing-error-message">{errorMessage2}</div>}
        {errorMessage && <div className="billing-error-message">{errorMessage}</div>}
        {errorMessage3 && <div className="billing-error-message">{errorMessage3}</div>}
        <form className="form-horizontal" onSubmit={downloadStudies}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', gap: 60 }}>
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              {/* <label className="control-label" style={{ marginRight: '10px' }} htmlFor="fromDate">From Date:</label> */}
              <div className="billing-input-group date" style={{ minWidth: '140px', width: '75%' }}>
                <DatePicker
                  label="From Date*"
                  placeholder="yyyy-mm-dd"
                  ariaLabel="Select a date"
                  value={fromDate}
                  onSelectDate={(date) => { setFromDate(date) }}
                  formatDate={dateFormatter}
                  
                />
                <span className="billing-input-group-addon"><i className="glyphicon glyphicon-th"></i></span>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              {/* <label className="control-label" style={{ marginRight: '10px' }} htmlFor="toDate">To Date:</label> */}
              <div className="billing-input-group date" style={{ minWidth: '140px', width: '75%' }}>
                <DatePicker
                  label='To Date*'
                  placeholder="yyyy-MM-dd"
                  value={toDate}
                  onSelectDate={(date) => { setToDate(date) }}
                  formatDate={dateFormatter}
                  
                />
                <span className="billing-input-group-addon"><i className="glyphicon glyphicon-th"></i></span>
              </div>
            </div>
          </div>
          <div style={{ justifyContent: 'space-evenly', marginTop: '10px', alignItems: 'flex-start' }}>
            {/* <label className="control-label" htmlFor="sheetType">Type :</label> */}
            <Dropdown
              label="Sheet Type*"
              placeholder='Select'
              style={{ width: '50%' }}
              options={[
                { key: 'TELE', text: 'TELE' },
                { key: 'PLATFORM', text: 'PLATFORM' },
                { key: 'CHAI', text: 'CHAI' }
              ]}

              onChange={(e, option) => setSheetType(option.key)}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            <button type="submit" className="billing-btn btn-primary">Download</button>
          </div>
        </form>
      </div>
    </div>
    </>
  );
}

export default BillingDownloadDataForm;
